import { useState, useEffect } from 'react';
import { getProviderPrivateFileSigned } from 'api/common';

const usePrivateFilePreview = (fileKey?: string) => {
    const [previewUrl, setPreviewUrl] = useState<string | undefined>(undefined);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!fileKey) {
            setPreviewUrl(undefined);
            return;
        }

        let cancelled = false;

        const fetchPreview = async () => {
            setLoading(true);
            try {
                const res = await getProviderPrivateFileSigned(fileKey);
                if (!cancelled && !res.error && res.data?.data?.singedUrl) {
                    setPreviewUrl(res.data.data.singedUrl);
                }
            } catch (e) {
                console.error(e);
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        };

        fetchPreview();

        return () => {
            cancelled = true;
        };
    }, [fileKey]);

    return { previewUrl, loading };
};

export default usePrivateFilePreview;
